export const MAX_TAGS_IN_GROUP = 10
export const MAX_TAGS_IN_USER = 10
